import React, { useState, useRef, Fragment } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputKidsMulti from "../../helpers/InputKidsMulti";
import InputCombo from "../../helpers/InputCombo";
import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputDecimal from "../../helpers/InputDecimal";

import edit from "../../edit.png";
import trash from "../../trash.png";
import back from "../../back.png";
import InputComboStawkiDoc from "../../helpers/InputComboStawkiDoc";


function InvoiceNew(props)
{ 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [iloscWys, setIloscWys] = useState(3); 

    const pozycje = [
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00, usunieta: 0   },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00,cena_j_brutto: 0.00,  stawka_vat: 0.00 , razem_brutto: 0.00, usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00 , razem_brutto: 0.00, usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00,cena_j_brutto: 0.00,  stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
        {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00, cena_j_brutto: 0.00, stawka_vat: 0.00, razem_brutto: 0.00 , usunieta: 0  },
    ];



    const getDateYmd = () => {
            const dateObj = new Date();
            const month   = dateObj.getUTCMonth() + 1; // months from 1-12
            const day     = dateObj.getUTCDate();
            const year    = dateObj.getUTCFullYear();

           // const newDate = year + "/" + month + "/" + day;

            // Using template literals:
           // const newDate = `${year}/${month}/${day}`;

            // Using padded values, so that 2023/1/7 becomes 2023/01/07
            const pMonth        = month.toString().padStart(2,"0");
            const pDay          = day.toString().padStart(2,"0");
            const newPaddedDate = `${year}-${pMonth}-${pDay}`;

            return newPaddedDate;
    }

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        dzieci: [],


        sposob_platnosci: 'Przelew',
        p_subkonta_id: '_x_',
        p_subkonta_id_valid: false,

        typ_dokumentu: 'r', // r lub f
        faktura_vat_postawa: 'netto',  //netto brutto

        odsetki_ustawowe: '0',

        data_wystawienia: getDateYmd(),
        data_wystawienia_valid: true,
        data_sprzedazy: getDateYmd(),
        data_sprzedazy_valid: true,
        termin_platnosci: getDateYmd(),
        termin_platnosci_valid: true,

        okres_od: '',
        okres_do: '',
        wystawil: '',

        platnik_nazwa: '',
        platnik_ulica_nr_domu: '',
        platnik_kod_pocztowy: '',
        platnik_miasto: '',
        platnik_nip: '',

        pozycje: pozycje,
        razem_brutto : 0.00,

        info_dodatkowe_na_fakturze: '',

    });

    const [checked, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked);
      };


    const onKidsSelected = (tab) => {
        setRow( {...row, ["dzieci"]: tab  } );
    }



    const valChangeListener = (filedName, val, correct, msg) => { 
        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      
  
  
          var sp = filedName.split('@');
   
  
  
          if(sp.length == 2 && row.faktura_vat_postawa == 'netto')
          {
              var inx    = sp[1];
              var filedN = sp[0];
  
              var newArr = new Array();
              var razemBrutto = 0.00;
              
              for(var k=0; k<row.pozycje.length;  k++)
              {            
                  if(k == inx)
                  {                    
                      row.pozycje[k][filedN] = val;                                    
                  }
  
                  var cena_j_netto  = parseFloat( row.pozycje[k]["cena_j_netto"]).toFixed(2) ;
                  var ilosc         = parseFloat( row.pozycje[k]["ilosc"]).toFixed(2) ;
                  var stawka_vat    = parseFloat( row.pozycje[k]["stawka_vat"]).toFixed(2) ;
  
                  if( isNaN(cena_j_netto)  ) cena_j_netto = 0;
                  if(isNaN(ilosc) ) ilosc = 0;
                  if(isNaN(stawka_vat) ) stawka_vat = 0;
  
                  var razemNetto = parseFloat( parseFloat(cena_j_netto) *  parseFloat(ilosc) ).toFixed(2);
  
                  var st = parseFloat( parseFloat(stawka_vat) / 100 ).toFixed(2);
                  var vat = parseFloat( parseFloat(razemNetto) * parseFloat(st) ).toFixed(2);
  
                  
  
                  var brutto = parseFloat( parseFloat(razemNetto) + parseFloat(vat) ).toFixed(2);
  
                //  console.log("Zmiana " + filedName+", netto: ", razemNetto,  "VAT: ", vat, "brutto: ",brutto);
                  
  
  
                  if( row.pozycje[k]["nazwa"].length < 1) 
                  {
                      brutto = 0.00;
                  }
              
                  row.pozycje[k]["kwota_netto"] = razemNetto;
                  row.pozycje[k]["kwota_vat"] = vat;
                  row.pozycje[k]["kwota_brutto"] = brutto;
  
                  row.pozycje[k]["cena_j_brutto"] = parseFloat( parseFloat(brutto) / parseFloat(ilosc) ).toFixed(2);;
  
      
  
                  newArr.push( row.pozycje[k] );                
              }
  
  
              for(var k=0; k<newArr.length;k++)
              {               
                  razemBrutto = parseFloat(  parseFloat( razemBrutto) + parseFloat( newArr[k]['kwota_brutto'])  ).toFixed(2);             
                 // console.log("Brutto (" + k + ") " + razemBrutto);
              }
   
  
   
  
              setRow( {...row, ['pozycje']:newArr,  ["razem_brutto"]: razemBrutto } ); 
  
              return;
          }
  
          if(sp.length == 2 && row.faktura_vat_postawa == 'brutto')
              {
                  var inx    = sp[1];
                  var filedN = sp[0];
      
                  var newArr = new Array();
                  var razemBrutto = 0.00;
                  
                  for(var k=0; k<row.pozycje.length;  k++)
                  {            
                      if(k == inx)
                      {                    
                          row.pozycje[k][filedN] = val;                                    
                      }
      
                      var cena_j_brutto  = parseFloat( row.pozycje[k]["cena_j_brutto"]).toFixed(2) ;
                      var ilosc         = parseFloat( row.pozycje[k]["ilosc"]).toFixed(2) ;
                      var stawka_vat    = parseFloat( row.pozycje[k]["stawka_vat"]).toFixed(2) ;
      
                      if( isNaN(cena_j_brutto)  ) cena_j_brutto = 0;
                      if(isNaN(ilosc) ) ilosc = 0;
                      if(isNaN(stawka_vat) ) stawka_vat = 0;
      
                      var brutto = parseFloat( cena_j_brutto * ilosc ).toFixed(2);
      
                      var st = parseFloat( stawka_vat / 100 ).toFixed(2);                
                      st     = parseFloat( parseFloat(st)  + 1.00 ).toFixed(2);


                  
                 
  
                      var razemNetto = parseFloat(  parseFloat(brutto) /  parseFloat(st) ).toFixed(2);
      
                      var vat = parseFloat(  parseFloat(brutto) - parseFloat(razemNetto) ).toFixed(2);                              
  
                       
                    
      
                      if( row.pozycje[k]["nazwa"].length < 1) 
                      {
                          brutto = 0.00;
                      }
                  
                      row.pozycje[k]["kwota_netto"] = razemNetto;
                      row.pozycje[k]["kwota_vat"] = vat;
                      row.pozycje[k]["kwota_brutto"] = brutto;
      
                      row.pozycje[k]["cena_j_netto"] =   parseFloat(   parseFloat( razemNetto) /  parseFloat( ilosc) ).toFixed(2);
      
                   
      
                      newArr.push( row.pozycje[k] );                
                  }
      
      
                  for(var k=0; k<newArr.length;k++)
                  {               
                      razemBrutto = parseFloat(  parseFloat( razemBrutto) + parseFloat( newArr[k]['kwota_brutto'])  ).toFixed(2);             
                     // console.log("Brutto (" + k + ") " + razemBrutto);
                  }
       
      
       
      
                  setRow( {...row, ['pozycje']:newArr,  ["razem_brutto"]: razemBrutto } ); 
      
                  return;
              }
  
  
          setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct  } );         
      }
  

 


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }





    const saveData = (e) => {



        if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }


        if(row.dzieci.length < 1) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dziecka' ,  "ok"  ,null); 
                return; 
            }


            
        var iloscPoz = 0;
            for(var k=0; k<row.pozycje.length;  k++)
                { 
                    if(row.pozycje[k]['nazwa'].length > 0 &&  row.pozycje[k]['cena_j_netto'] != 0   )
                    {
                        iloscPoz++;
                    }
                }    

       


        if( iloscPoz < 1) 
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie dodano żadnej pozycji.' ,  "ok"  ,null); 
                    return; 
                }            
 

      


        props.mainView.setProgress(-2);


    
        fetch( Config.url + '/rest_v1_calc,create_invoice', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                props.mainView.showDialog( "Sukces", 'Utworzono: ' + res.result, "ok" , null); 
                                props.goBack();
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }




    const onBack = (e) => {
        props.goBack();
    }



    const dodajPozycje = () => {
        setIloscWys(iloscWys + 1);
    }

    const usunPozycje = (e) => {

        var ix = e.target.getAttribute('ix');


        var newArr = new Array();
            
        for(var k=0;k<row.pozycje.length; k++)
        {
            if(k == ix)
            {
                row.pozycje[k]["nazwa"] = "";             
                row.pozycje[k]["usunieta"] = 1;             
                row.pozycje[k]["cena_j_netto"] = 0;             
                row.pozycje[k]["razem_brutto"] = 0;             
                row.pozycje[k]["ilosc"] = 0;             
            }

            newArr.push( row.pozycje[k] );
        }

        setRow( {...row, ['pozycje']:newArr } ); 
      

         //przelicz wszystko..
         setTimeout(  ()=> {
            valChangeListener("nazwa@"+k, "",true,"");
        }, 500 );

    }



    const onSelectPosition = (param, stRecord) => {

        console.log(param, stRecord);


        var ix =  param;  //e.target.getAttribute('ix');

        var typ_wlasny = 'Inne';
        var jm = 'sztuki';

        if(stRecord.opl_czesne == '1') 
        {
            typ_wlasny = "Czesne";
            jm = "miesiąc";
        }

        if(stRecord.opl_wyzywienie == '1')
        {
             typ_wlasny = "Wyżywienie";
             jm = "dzień";
        }

        var newArr = new Array();
            
        for(var k=0;k<row.pozycje.length; k++)
        {
            if(k == ix)
            {
                row.pozycje[k]["nazwa"] = stRecord.nazwa;             
                row.pozycje[k]["usunieta"] = 0;             
                row.pozycje[k]["cena_j_netto"] = stRecord.kwota_netto;             
                row.pozycje[k]["razem_brutto"] = stRecord.kwota_netto;             
                row.pozycje[k]["ilosc"] = 1;             
                row.pozycje[k]["typ_wlasny"] = typ_wlasny;
                row.pozycje[k]["jm"] = jm;
            }

            newArr.push( row.pozycje[k] );
        }

        setRow( {...row, ['pozycje']:newArr } ); 
      

         //przelicz wszystko..
         setTimeout(  ()=> {
            valChangeListener("nazwa@"+k, "",true,"");
        }, 500 );


    }


    const itemsTypDokumentu = [    
        { v: 'r', title: 'Zwykłe rozliczenie' },        
        { v: 'f', title: 'Faktura' },         
    ]; 


    const itemsSposobPlatnoci = [    
        { v: 'Gotówka', title: 'Gotówka' },        
        { v: 'Przelew', title: 'Przelew' },         
    ]; 

    const itemsJM = [    
        { v: 'godzina', title: 'Godzina' },        
        { v: 'dzień',   title: 'Dzień' },         
        { v: 'sztuki',  title: 'Sztuki' },         
        { v: 'miesiąc', title: 'Miesiąc' },         
    ]; 


    const itemsTyp = [    
        { v: 'Czesne', title: 'Czesne' },        
        { v: 'Wyżywienie',   title: 'Wyżywienie' },         
        { v: 'Inne',  title: 'Inne' },                 
    ]; 


    const itemsPodstawa = [    
        { v: 'netto', title: 'Netto' },        
        { v: 'brutto',   title: 'Brutto' },         
                 
    ]; 



    var xTitle = "Nowy rachunek";
    if(row.typ_dokumentu == 'f') xTitle = "Nowa faktura";

 



 

    return <div className="view_content">

                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>

                    <h1>{xTitle}</h1>
                      
                    <form className="eForm bg_center">

                            <div className="form_tab_title">Wybierz min. jedno dziecko</div>
                            <div className="form_tab">               
                                        <InputKidsMulti   userData={props.userData}  mainView={props.mainView} onKidsSelected={onKidsSelected}   />  
                            </div>


                            <div className="form_tab_title">Dane podstawowe</div>
                            <div className="form_tab">
                           

                                <div className="form_control">
                                                <div className="fieldName">Typ wystawianego dokumentu</div>
                                                <InputCombo items={itemsTypDokumentu} value={row.typ_dokumentu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_dokumentu" placeholder={""} className='  ' req='1'   />                                    
                                </div>

                                {
                                    row.typ_dokumentu == 'f' &&
                                    <div className="form_control">
                                        <div className="fieldName">Podstawa</div>
                                        <InputCombo items={itemsPodstawa} value={row.faktura_vat_postawa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="faktura_vat_postawa" placeholder={""} className='  ' req='1'   />                                    
                                    </div>
                                }
                               
                              


                                <div className="form_control">
                                                <div className="fieldName">Konto</div>
                                                <InputComboSubkonto  userData={props.userData} mainView={props.mainView}  value={row.p_subkonta_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_subkonta_id" placeholder={""} className='  ' req='1'   />                                    
                                </div>

                                <br/>
                                 



                                <div className="form_control">
                                        <div className="fieldName">Data wystawienia* </div>
                                        <InputDate   userData={props.userData} value={row.data_wystawienia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia" placeholder={""} className=' ' req='1'   />
                                </div>

                                <div className="form_control">
                                        <div className="fieldName">Data sprzedaży* </div>
                                        <InputDate   userData={props.userData} value={row.data_sprzedazy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_sprzedazy" placeholder={""} className=' ' req='1'   />
                                </div>

                                <div className="form_control">
                                        <div className="fieldName">Termin płatności* </div>
                                        <InputDate   userData={props.userData} value={row.termin_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="termin_platnosci" placeholder={""} className=' ' req='1'   />
                                </div>

                                <div className="form_control">
                                                <div className="fieldName">Sposób płatności</div>
                                                <InputCombo items={itemsSposobPlatnoci} value={row.sposob_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sposob_platnosci" placeholder={""} className='  ' req='1'   />                                    
                                </div>


                            </div>

                            <div className="form_tab_title">
                            
                                    <label className="switch" title={props.userData.dic.showmore}>                               
                                        <input type="checkbox" checked={checked}  onChange={handleChange}/>
                                        <span className="slider round"></span>
                                    </label>  
                                    &nbsp;
                                    Płatnik (wypełnij jeżeli inny niż rodzic np. ośrodek pomocy społecznej, fundacja) 
                            </div>

                            { checked && 
                            <div className="form_tab">


                               <div className="form_control">
                                                    <div className="fieldName">NIP</div>
                                                    <InputNIP   userData={props.userData} value={row.platnik_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_nip" placeholder={""} className='w200' req='0'   />
                                </div>

                                <div className="form_control">
                                                    <div className="fieldName">Nazwa</div>
                                                    <InputText   userData={props.userData} value={row.platnik_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_nazwa" placeholder={""} className='w400' req='0'   />
                                </div>
                           

                                <br/>

                                <div className="form_control">
                                                    <div className="fieldName">Ulica, nr domu</div>
                                                    <InputText   userData={props.userData} value={row.platnik_ulica_nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_ulica_nr_domu" placeholder={""} className='w300' req='0'   />
                                </div>

                                <div className="form_control">
                                                    <div className="fieldName">Kod pocztowy</div>
                                                    <InputPostCode   userData={props.userData} value={row.platnik_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_kod_pocztowy" placeholder={""} className='w100' req='0'   />
                                </div>

                                <div className="form_control">
                                                    <div className="fieldName">Miasto</div>
                                                    <InputText   userData={props.userData} value={row.platnik_miasto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_miasto" placeholder={""} className='w200' req='0'   />
                                </div>

                            </div>
                            }

                            <div className="form_tab_title">Informacje dodatkowe</div>
                            <div className="form_tab">
                                   <div className="form_control">
                                                    <div className="fieldName">Informacja widniejąca w stopce faktury (np. zwolnienie z podatku...)</div>
                                                    <InputText   userData={props.userData} value={row.info_dodatkowe_na_fakturze} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="info_dodatkowe_na_fakturze" placeholder={""} className='w400' req='0'   />
                                    </div>
                            </div>

                            <br/>

                            {
                                row.faktura_vat_postawa == "netto" &&
                                <Fragment>
                                            <div className="form_tab_title">Pozycje na rozliczeniu (podstawa: <b>{row.faktura_vat_postawa}</b> )</div>
                                                                        <div  className={"form_tab  tdoc_" + row.typ_dokumentu}  >

                                                                                {
                                                                                    row.pozycje.map((poz, ix) => {

                                                                                        if(ix >= iloscWys) return null;
                                                                                        if( row.pozycje[ix].usunieta == 1  ) return null;

                                                                                        return <div>

                                                                                            

                                                                                                <div className="form_control"> 
                                                                                                    <div className="fieldName">Rodzaj</div>                                                       
                                                                                                    <InputCombo items={itemsTyp} value={row.pozycje[ix].typ_wlasny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"typ_wlasny@"+ix} placeholder={""} className='  ' req='0'   />  
                                                                                                </div>

                                                                                                <div className="form_control">      
                                                                                                    <div className="fieldName">Nazwa pozycji <sup> <InputComboStawkiDoc   userData={props.userData}  mainView={props.mainView} param={ix} onSelect={onSelectPosition} /></sup> </div>
                                                                                                    <InputText   userData={props.userData} value={row.pozycje[ix].nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"nazwa@"+ix} placeholder={"Nazwa: np. Czesne z X"} className='w300' req='0'   />                                                                                                     
                                                                                                </div>

                                                                                                <div className="form_control">      
                                                                                                    <div className="fieldName">Cena netto</div>
                                                                                                    <InputDecimal   userData={props.userData} value={row.pozycje[ix].cena_j_netto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"cena_j_netto@"+ix} placeholder={"Cena:"} className='w50' req='0'   />
                                                                                                </div>

                                                                                                <div className="form_control">      
                                                                                                    <div className="fieldName">Ilość</div>
                                                                                                    <InputDecimal   userData={props.userData} value={row.pozycje[ix].ilosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"ilosc@"+ix} placeholder={"Ilość:"} className='w50' req='0'   />
                                                                                                </div>

                                                                                                <div className="form_control"> 
                                                                                                    <div className="fieldName">JM</div>                                                       
                                                                                                    <InputCombo items={itemsJM} value={row.pozycje[ix].jm} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"jm@"+ix} placeholder={""} className='  ' req='0'   />  
                                                                                                </div>

                                                                                            {
                                                                                                row.typ_dokumentu == 'f' &&
                                                                                                <div className="form_control">      
                                                                                                        <div className="fieldName">Stawka VAT</div>
                                                                                                       <InputDecimal   userData={props.userData} value={row.pozycje[ix].stawka_vat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"stawka_vat@"+ix} placeholder={"Stawka VAT:"} className='w50' req='0'   />
                                                                                                </div>
                                                                                            }
                                                                                               

                                                                                                   
                                                                                                {
                                                                                                      row.typ_dokumentu == 'f' &&
                                                                                                      <div className="form_control">                                                                                                 
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_netto).toFixed(2) }<br/>netto</div>                                                                                                   
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_vat).toFixed(2) }<br/>vat</div>                                                                                            
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_brutto).toFixed(2) }<br/>brutto</div>
                                                                                                      </div>
                                                                                                }
                                                                                               
                                                                                               {
                                                                                                      row.typ_dokumentu == 'r' &&
                                                                                                      <div className="form_control">                                                                                                                                                                                                                                                                                          
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_brutto).toFixed(2) } razem</div>
                                                                                                      </div>
                                                                                                }

                                                                                                <div className="form_control"> 
                                                                                                &nbsp; &nbsp;   <img className="ibtn" src={trash} title="usuń"  onClick={usunPozycje}   ix={ix} />
                                                                                                </div>

                                                                                                

                                                                                        </div>


                                                                                    } )

                                                                                }

                                                                        
                                                                            <span onClick={dodajPozycje} className="link_color">
                                                                                dodaj pozycje +
                                                                            </span>   

                                                                                <br/>
                                                                                <br/>
                                                                                <br/>

                                                                                <div>
                                                                                <strong>Razem: { parseFloat(row.razem_brutto).toFixed(2) }</strong>
                                                                                </div>  


                                                                        </div>
                                </Fragment>
                            }

                            
                            {
                                row.faktura_vat_postawa == "brutto" &&
                                <Fragment>
                                     <div className="form_tab_title">Pozycje na rozliczeniu (podstawa: <b>{row.faktura_vat_postawa}</b> )</div>
                                                                        <div className={"form_tab  tdoc_" + row.typ_dokumentu}  >

                                                                                {
                                                                                    row.pozycje.map((poz, ix) => {

                                                                                        if(ix >= iloscWys) return null;
                                                                                        if( row.pozycje[ix].usunieta == 1  ) return null;

                                                                                        return <div>

                                                                                            

                                                                                                <div className="form_control"> 
                                                                                                    <div className="fieldName">Rodzaj</div>                                                       
                                                                                                    <InputCombo items={itemsTyp} value={row.pozycje[ix].typ_wlasny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"typ_wlasny@"+ix} placeholder={""} className='  ' req='0'   />  
                                                                                                </div>

                                                                                                <div className="form_control">      
                                                                                                    <div className="fieldName">Nazwa pozycji <sup> <InputComboStawkiDoc   userData={props.userData}  mainView={props.mainView} param={ix} onSelect={onSelectPosition} /></sup> </div>
                                                                                                    <InputText   userData={props.userData} value={row.pozycje[ix].nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"nazwa@"+ix} placeholder={"Nazwa: np. Czesne z X"} className='w300' req='0'   />
                                                                                                                                                                                                     
                                                                                                </div>


                                                                                                

                                                                                                <div className="form_control">      
                                                                                                    <div className="fieldName">Cena brutto</div>
                                                                                                    <InputDecimal   userData={props.userData} value={row.pozycje[ix].cena_j_brutto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"cena_j_brutto@"+ix} placeholder={"Cena:"} className='w50' req='0'   />
                                                                                                </div>

                                                                                                <div className="form_control">      
                                                                                                    <div className="fieldName">Ilość</div>
                                                                                                    <InputDecimal   userData={props.userData} value={row.pozycje[ix].ilosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"ilosc@"+ix} placeholder={"Ilość:"} className='w50' req='0'   />
                                                                                                </div>

                                                                                                <div className="form_control"> 
                                                                                                    <div className="fieldName">JM</div>                                                       
                                                                                                    <InputCombo items={itemsJM} value={row.pozycje[ix].jm} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"jm@"+ix} placeholder={""} className='  ' req='0'   />  
                                                                                                </div>


                                                                                                {
                                                                                                row.typ_dokumentu == 'f' &&
                                                                                                <div className="form_control">      
                                                                                                        <div className="fieldName">Stawka VAT</div>
                                                                                                       <InputDecimal   userData={props.userData} value={row.pozycje[ix].stawka_vat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"stawka_vat@"+ix} placeholder={"Stawka VAT:"} className='w50' req='0'   />
                                                                                                </div>
                                                                                                }

                                                                                                
                                                                                                {
                                                                                                      row.typ_dokumentu == 'f' &&
                                                                                                      <div className="form_control">                                                                                                 
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_netto).toFixed(2) }<br/>netto</div>                                                                                                   
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_vat).toFixed(2) }<br/>vat</div>                                                                                            
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_brutto).toFixed(2) }<br/>brutto</div>
                                                                                                      </div>
                                                                                                }
                                                                                               
                                                                                               {
                                                                                                      row.typ_dokumentu == 'r' &&
                                                                                                      <div className="form_control">                                                                                                                                                                                                                                                                                          
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_brutto).toFixed(2) } razem</div>
                                                                                                      </div>
                                                                                                }


                                                                                                <div className="form_control"> 
                                                                                                &nbsp; &nbsp;   <img className="ibtn" src={trash} title="usuń"  onClick={usunPozycje}   ix={ix} />
                                                                                                </div>

                                                                                                

                                                                                        </div>


                                                                                    } )

                                                                                }

                                                                        
                                                                            <span onClick={dodajPozycje} className="link_color">
                                                                                dodaj pozycje +
                                                                            </span>   

                                                                                <br/>
                                                                                <br/>
                                                                                <br/>

                                                                                <div>
                                                                                <strong>Razem: { parseFloat(row.razem_brutto).toFixed(2) }</strong>
                                                                                </div>  


                                                                        </div>
                                </Fragment>
                            }



                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn" onClick={saveData}>Wystaw</div>
                                    &nbsp;
                                    <div className="btn" onClick={onBack}>Anuluj</div>
                            </div>


                    </form>

    </div>
}



export default InvoiceNew;


